import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useThemeStore = defineStore('theme', () => {
  const isDark = ref(
    localStorage.getItem('theme') === 'dark' ||
    (!localStorage.getItem('theme') && window.matchMedia('(prefers-color-scheme: dark)').matches)
  )

  const toggleTheme = () => {
    isDark.value = !isDark.value
    updateTheme()
  }

  const updateTheme = () => {
    // Update localStorage
    localStorage.setItem('theme', isDark.value ? 'dark' : 'light')

    // Update document class for PrimeVue dark mode selector
    const htmlElement = document.documentElement

    if (isDark.value) {
      htmlElement.classList.add('p-dark')
    } else {
      htmlElement.classList.remove('p-dark')
    }
  }

  // Initialize theme on store creation
  updateTheme()

  // Watch for system theme changes when no explicit preference is set
  const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
  mediaQuery.addEventListener('change', (e) => {
    if (!localStorage.getItem('theme')) {
      isDark.value = e.matches
      updateTheme()
    }
  })

  return {
    isDark,
    toggleTheme,
    updateTheme
  }
})
